/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-12 10:50:50
 * @modify date 2023-11-12 10:50:50
 * @desc [description]
 */

import { ListTableHeader } from "components/base/table/listTableType";
import i18n from "lang/base";
import { View, Text } from "react-native";
import { FONT } from "value/staticValues";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";


interface PoolData {
  pool_name: string;
  type: string;
  size: number;
  min_size: number
}


interface ServiceData {
  host_name: string;
  version: string;
  type: string;
  osd_id: string;
  up_yn: boolean;
  osd_total_capacity_gb: number;
  osd_used_capacity_gb: number;
}


export interface StorageDetailData {
  storage_pool_id: string;
  storage_pool_name: string;
  ip_address: string;
  up_yn: boolean;
  location_info: string;
  max_over_subscription_ratio: number;
  multiattach_yn: boolean;
  storage_protocol_type_code: string;
  thin_provisioning_support_yn: boolean;
  storage_pool_total_capacity_gb: number;
  storage_pool_allocated_capacity_gb: number;
  storage_pool_free_capacity_gb: number;
  volume_backend_name: string;
  create_ts: string;
  update_ts: string;
  region: {
    region_id: string;
    region_name: string;
  }
  pools: PoolData[]
  services: ServiceData[]
}


export const initStorageDetailData = {
  storage_pool_id: '',
  storage_pool_name: '',
  ip_address: '',
  up_yn: false,
  location_info: '',
  max_over_subscription_ratio: 0,
  multiattach_yn: false,
  storage_protocol_type_code: '',
  thin_provisioning_support_yn: false,
  storage_pool_total_capacity_gb: 0,
  storage_pool_allocated_capacity_gb: 0,
  storage_pool_free_capacity_gb: 0,
  volume_backend_name: '',
  create_ts: '',
  update_ts: '',
  region: {
    region_id: '',
    region_name: '',
  },
  pools: [],
  services: []
}




export const svcTableColumns:ListTableHeader[] = [
  {
    Header: i18n.t("STORAGE_NODE_NAME_TEXT"),
    accessor: "host_name",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
  },
  {
    Header: i18n.t("STORAGE_SERVICE_TYPE_TEXT"),
    accessor: "type",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
  },
  {
    Header: i18n.t("STORAGE_OSD_STATE_TEXT"),
    accessor: "up_yn",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (
      <div style={{
          display: "flex", alignItems: "center",
          fontFamily: FONT.REGULAR,
          fontSize: 12,
          color: value ? "#3a8344" : "#8c8c8c",
      }}>
          {
              value === true
              ?
                  <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                      <StatusStableImg style={className.statusImg}/>
                      <Text style={{lineHeight: 12, fontSize: 12, alignSelf: 'center'}}>Up</Text>
                  </View>
              : value === false
              ?    <View style={{flexDirection: 'row', justifyContent: 'center'}}>
                      <StatusBlockImg style={className.statusImg}/>
                      <Text style={{lineHeight: 12, fontSize: 12, alignSelf: 'center'}}>Down</Text>
                  </View>
              : null
          }

      </div>
  )
  },
  {
    Header: i18n.t("STORAGE_OSD_INDEX_TEXT"),
    accessor: "osd_id",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? value : ""}</div>)
  },
  {
    Header: i18n.t("STORAGE_OSD_TOTAL_CAPACITY_TEXT"),
    accessor: "osd_total_capacity_gb",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{typeof value === "number" ? value + ' GB' : ""}</div>)
  },
  {
    Header:i18n.t("STORAGE_OSD_USED_CAPACITY_TEXT"),
    accessor: "osd_used_capacity_gb",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{typeof value === "number" ? value + ' GB' : ""}</div>)
  },
  {
    Header: i18n.t("STORAGE_SW_VERSION_TEXT"),
    accessor: "version",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
  },
]




export const storagePoolTableColumns:ListTableHeader[] = [
  {
    Header: "스토리지 풀 이름",
    accessor: "pool_name",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
  },
  {
    Header: "스토리지 풀 타입",
    accessor: "type",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
  },
  {
    Header: "복제 사이즈",
    accessor: "size",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
  },
  {
    Header: "최소 복제 사이즈",
    accessor: "min_size",
    disableSortBy: false,
    style: {
        width: "150px",
    },
    Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
  },
]




const className = {
  statusContainer: {
      width: 56,
      display: "flex", Jusitipy: "center", justifyContent: "center",
      borderRadius: 10,
      backgroundColor: "#b6bfce",
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#fff"
  },
  normalTextContainer: {
      fontFamily: FONT.REGULAR,
      fontSize: 12,
      color: "#333",
      overflow: "hidden"
  },
  dateContainer: {
      color: "#9ea0a5",
  },
  resourceContainer: {
      color: "#0853fb"
  },
  statusImg: {
      marginRight: 3
  },
  resourceImg: {
      width: 24,
      height: 24
  },
  usageContainer: {
      paddingLeft: 20
  },
  usageRowContainer: {
      width: "120px",
      display: "flex",
      alignItems: "center"
  },
  usageImg: {
      width: "24px",
      height: "24px",
      filter: "opacity(0.5)"
  },
  usageText: {
      fontFamily: FONT.REGULAR,
      fontSize: "10px",
      color: "#8793a3"
  },
  usageStorageValue: {
      marginLeft: "auto",
      marginRight: "5px",
      fontFamily: FONT.MEDIUM,
      fontSize: "12px",
      color: "#5a7ee9"
  },
  usageWarnValue: {
      marginLeft: "auto",
      marginRight: "5px",
      fontFamily: FONT.MEDIUM,
      fontSize: "12px",
      color: "#e6735c"
  },
  warnImg: {
      width: 20,
      height: 20
  },
  osdBox: {
      width: 20,
      height: 20,
      borderRadius: 2,
      backgroundColor: "#5a7ee9",
      display: "flex",
      alignItems: "center",
      justifyContents: "center"
  }
}